export const statusVariant = (status) => {
  switch ((status || '').toLowerCase()) {
    case 'active':
      return 'success';
    case 'closed':
      return 'secondary';
    case 'closing':
      return 'warning';
    case 'draft':
    default:
      return 'outline';
  }
};

const invitationBaseClass = 'whitespace-nowrap shrink-0 font-medium';

export const getInvitationStatusBadgeProps = (status) => {
  const s = String(status || '').toLowerCase();
  if (s === 'completed' || s === 'submitted') {
    return { variant: 'success', className: invitationBaseClass };
  }
  if (s === 'started' || s === 'in_progress') {
    return { variant: 'info', className: invitationBaseClass };
  }
  if (s === 'sent') {
    return { variant: 'warning', className: invitationBaseClass };
  }
  if (s === 'revoked' || s === 'excluded') {
    return { variant: 'destructive', className: invitationBaseClass };
  }
  return {
    variant: 'outline',
    className: `${invitationBaseClass} border-border bg-background text-foreground`,
  };
};

export const prettyDate = (value) => {
  if (!value) return '—';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return value;
  return date.toLocaleDateString(undefined, { day: '2-digit', month: 'short', year: 'numeric' });
};
